import {
	SET_MEMBER_INFO ,
    SET_MEMBER_TOKEN, 
    SET_MEMBER_PROFILE,
    SET_MEMBER_PHOTO,
    UPDATE_MEMBER_INFO,
} from './actionTypes';

const initState = {
    token: '',
    name: '',
    surname: '',
    high_division: false,
    is_patronager: false,
    is_observer: false,
    is_diaspora_coordinator: false,
    member_data: null,
    memberProfile: null,
    memberRole: null
}

const Member = (state = initState, action) => {
	switch (action.type) {
		case SET_MEMBER_INFO:
			return {
				...state,
				name: action.payload.name,
                surname: action.payload.surname,
                high_division: action.payload.dashboardspecial_status,
                is_patronager: action.payload.is_patronager,
                is_diaspora_coordinator: action.payload.is_diaspora_coordinator,
                is_ftv_coordinator: action.payload.is_ftv_coordinator,
                observer: action.payload.observer,
                is_observer: action.payload.observer ? true : false,
                observer_id: action.payload.observer ? action.payload.observer.observer_id : null,
                member_data: action.payload
			};
        
        case SET_MEMBER_TOKEN:
            return {
                ...state,
                token: action.payload
            };
        case SET_MEMBER_PROFILE:
            const profile_data = action.payload
            return {
                ...state,
                observer: profile_data.observer ? profile_data.observer : null,
                is_observer: profile_data.observer ? true : false,
                memberProfile: profile_data.member_profile,
                memberRole: profile_data.member_role
            }
        case SET_MEMBER_PHOTO:
            return {
                ...state, member_data: {...state.member_data, photo: action.payload}
            }; 
        case UPDATE_MEMBER_INFO:
            return {
                ...state, member_data: {...state.member_data, phone: action.payload.phone, email: action.payload.email}
            };         
		default:
			return state;
	}
}

// const isHighDivision = (division_level) => {
//     let highDivision = false;

//     if (division_level === 'COUNTRY' || division_level === 'DIVISION' || division_level === 'REGION' ) {
//         highDivision = true
//     }

//     return highDivision;
// };

export default Member